import { useState } from "react";
import { motion } from "framer-motion";
import { UtensilsCrossed, FlaskConical, Scissors, Layers, Newspaper, Factory, ChevronDown } from "lucide-react";
import { useLang } from "@/i18n";
import ThermalExplorer from "@/components/thermal/ThermalExplorer";

const industryIcons = [UtensilsCrossed, FlaskConical, Scissors, Layers, Newspaper, Factory];

export default function Applications() {
  const { t } = useLang();
  const [open, setOpen] = useState(null);
  const industries = t.apps.industries.map((ind, i) => ({ ...ind, icon: industryIcons[i] }));

  return (
    <section id="applicazioni" className="py-24 sm:py-32 border-b border-white/10" data-testid="applications-section">
      <div className="max-w-7xl mx-auto px-6">
        <motion.p initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="overline-tag" data-testid="applications-overline">
          {t.apps.overline}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }}
          className="mt-4 font-display font-bold tracking-tight text-3xl sm:text-4xl lg:text-5xl max-w-3xl"
        >
          {t.apps.h2}
        </motion.h2>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {industries.map((ind, i) => (
            <motion.div
              key={ind.name}
              initial={{ opacity: 0, y: 28 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: (i % 3) * 0.1 }}
              className={`glass rounded-2xl p-7 cursor-pointer transition-[border-color] duration-300 hover:border-volt/40 ${open === i ? "!border-volt/50" : ""}`}
              onClick={() => setOpen(open === i ? null : i)}
              role="button" aria-expanded={open === i} tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && setOpen(open === i ? null : i)}
              data-testid={`industry-card-${i}`}
            >
              <div className="flex items-start justify-between">
                <div className="w-11 h-11 rounded-xl bg-volt/10 border border-volt/20 flex items-center justify-center">
                  <ind.icon className="text-volt" size={20} strokeWidth={1.5} />
                </div>
                <ChevronDown size={18} className={`text-volt transition-transform duration-300 ${open === i ? "rotate-180" : ""}`} />
              </div>
              <h3 className="mt-5 font-display font-semibold text-lg">{ind.name}</h3>
              <p className="mt-2 text-sm text-steel leading-relaxed">{ind.use}</p>
              <div className={`grid transition-[grid-template-rows] duration-300 ${open === i ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
                <div className="overflow-hidden">
                  <p className="mt-4 text-[11px] font-semibold uppercase tracking-[0.2em] text-volt">{t.apps.detailLabel}</p>
                  <p className="mt-2 text-sm text-steel leading-relaxed">{ind.detail}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <ThermalExplorer />
      </div>
    </section>
  );
}
